export const actions: any = [
  {
    title: 'Add New Product',
    action: 'add-product',
    hidden: false,
    availableOn: ['working'],
    icon: 'add-icon',
  },
  {
    title: 'Add New From Current Item',
    action: 'add-product-from-current',
    hidden: false,
    availableOn: ['working'],
    icon: 'add-icon',
  },
  {
    title: 'Edit Columns',
    action: 'edit-columns',
    hidden: false,
    availableOn: ['working', 'published', 'view-export'],
    icon: 'columns-icon',
  },
  {
    title: 'View Archived Products',
    action: 'view-archived',
    hidden: false,
    availableOn: ['working'],
    icon: 'view-icon',
  },
];
